import { BaseApiService } from '@/services/base-service';
import {
  ApiPagination, BaseResponse, Filters, FiltersPagination, Response,
} from '@/types';
import { Notifications } from '../types';

interface NotificationsList extends BaseResponse, ApiPagination {
  data: {
    items: Notifications.Notification[],
  }
}

export class LastNotificationsService extends BaseApiService {
  private readonly base_path = '/notifications'

  async get_last_notifs(filters:FiltersPagination<Filters>): Promise<NotificationsList> {
    const payload = filters;

    const { data } = await this.http_client.get<NotificationsList>(this.base_path, {
      params: {
        limit: 10,
      },
    });

    return data;
  }

  async read_notifs(id:number): Promise<NotificationsList> {
    const { data } = await this.http_client.patch<NotificationsList>(this.base_path, {
      notification_ids: [id],
    });

    return data;
  }
}
